import React from 'react';
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Banner from "../components/home/Banner";
import Contact from '../components/home/Contact';
import FrequentlyAskedQuestions from '../components/home/FAQ';
import HomeSteps from "../components/home/HomeSteps";
import SubjectTopic from "../components/home/SubjectTopic";
import Testinomials from '../components/home/Testinomials';
import Universities from "../components/home/Universities";

const Offerings = () => {
  return (
    <section className="pb-10 rounded-3xl shadow-md mb-10">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold mb-4">Our Offerings</h2>
        <p className="text-gray-600 mb-8">
          We provide specialized courses for CUET, allowing students to select any three domain subjects along with General English and General Test.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 bg-white rounded-xl shadow-lg">
            <h3 className="text-xl font-semibold mb-2">Preparatory Modules</h3>
            <p className="text-gray-600">
              Each subject follows the latest CUET syllabus with topic-wise preparation modules. Each module includes:
            </p>
            <ul className="list-disc list-inside text-gray-600 text-left mt-2">
              <li>15 Practice Tests</li>
              <li>Each test has 20 carefully curated questions</li>
            </ul>
          </div>
          <div className="p-6 bg-white rounded-xl shadow-lg">
            <h3 className="text-xl font-semibold mb-2">Mock Tests</h3>
            <p className="text-gray-600">
              Get hands-on practice with tests modeled on the NTA platform. Features include:
            </p>
            <ul className="list-disc list-inside text-gray-600 text-left mt-2">
              <li>15 Mock Tests</li>
              <li>Each test follows the updated CUET pattern</li>
              <li>50 questions per mock test for rigorous practice</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

const Homepage = () => {
  return (
    <>
      <div className="bg-white overflow-hidden">
        <Navbar />
        <Banner />
        <Offerings />
        <SubjectTopic />
        <HomeSteps />
        <Universities />
        <Testinomials />
        <FrequentlyAskedQuestions />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default Homepage;
